import React from 'react'
import CrossSvg from '../../../../assets/images/cross-white.svg'
import './SearchWarning.scss'

const SearchWarning = ({ description, title, onClose }) => {

  return (
    <div className='search-warning-container'>
      <div className='search-warning-container-head'>
        <p>{title}</p>
        <div onClick={() => onClose()}>
          <img src={CrossSvg} alt='cerrar' />
        </div>
      </div>
      <div className='search-warning-container-body'>
        <p>{description}</p>
      </div>
    </div>
  )

}

export default SearchWarning
